import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cookie-consent',
  standalone: false,
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {

  showBanner = false;

  constructor(private cookieService: CookieService) {}

  ngOnInit() {
    const consent = this.cookieService.get('cookie_consent');

    if (!consent) {
      this.showBanner = true;
    } else {
      this.showBanner = false; 
    }
  }

  acceptCookies() {
    this.cookieService.set('cookie_consent', 'accepted', 365);
    this.showBanner = false;
    window.dispatchEvent(new Event("cookieConsentAccepted"));
  }

  rejectCookies() {
    this.cookieService.set('cookie_consent', 'rejected', 365);
    this.showBanner = false;
    window.dispatchEvent(new Event("cookieConsentRejected"));
  }
}
